module.exports = __webpack_public_path__ + "img/5xiao.3b244577.png";